<div class="modal-css modal-xl">
    <div class="modal-header">
        <h2 class="modal-title"></h2>
        <button type="button" class="btn" (click)="modalRef.close()">
            <img src="./assets/icon/close.svg" alt="Icona"/>
        </button>
    </div>
    <div class="modal-body">
        <h5 class="modal-title" style="text-align: center">{{ 'deleteuser' | translate }}</h5>
        <br>
        <div class="content-buttons d-flex flex-row flex-nowrap justify-content-center align-items-center">
            <button type="button" class="btn btn-primary" (click)="deleteuser()">{{ 'yes' | translate }}</button>
            <button type="button" class="btn btn-primary" (click)="modalRef.close()">{{ 'no' | translate }}</button>
        </div>
    </div>
</div>